// ============================================================================
// InfoPanel.jsx — Corelia UI v1.2
// Panneau informatif avec bande latérale, variantes et layout robuste
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";

const InfoPanel = ({
  title,
  message,
  variant = "grey",
  size = "md",   // Taille globale du panneau : "sm" | "md" | "lg" (contrôle padding et tailles de texte)
  stripPosition = "left",
  border = false,
  rounded = true,
  radius = null,
  paddingV = null,
  paddingH = null,
  style = {},
}) => {
  const palette = theme.InfoPanel[variant] || theme.InfoPanel.grey;
  const isLeft = stripPosition === "left";
  const sizeConfig = {
  sm: {
    paddingV: 4,
    paddingH: 8,
    titleSize: theme.fontSizes.xs,
    messageSize: theme.fontSizes.xs,
    gap: 2,
    stripWidth: 4,
  },
  md: {
    paddingV: 10,
    paddingH: 14,
    titleSize: theme.fontSizes.md,
    messageSize: theme.fontSizes.sm,
    gap: 4,
    stripWidth: 6,
  },
  lg: {
    paddingV: 14,
    paddingH: 18,
    titleSize: theme.fontSizes.lg,
    messageSize: theme.fontSizes.md,
    gap: 6,
    stripWidth: 8,
  },
};

const cfg = sizeConfig[size] || sizeConfig.md;

  // Radius résolu selon variant ou paramètre
  const resolvedRadius = rounded
    ? radius ?? theme.borders.radius.lg
    : 0;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isLeft ? "row" : "row-reverse",
        alignItems: "stretch",
        fontFamily: theme.form.label.fontFamily,
        fontSize: theme.fontSizes.md,
        color: palette.text,

        backgroundColor: palette.bg,
        borderRadius: resolvedRadius,
        boxShadow: theme.shadows.xs,
        border: border ? `1px solid ${palette.border}` : "none",

        margin: `${theme.spacing.xs}px 0 ${theme.spacing.md}px`,

        // Layout robuste
        flexShrink: 0,
        width: "100%",
        minWidth: 220,
        overflowX: "auto",       // autorise le scroll si contenu long
        flexWrap: "nowrap",

        ...style,
      }}
    >
      {/* Bande latérale */}
      <div
        style={{
          width: cfg.stripWidth,
          backgroundColor: palette.strip,
          borderTopLeftRadius: isLeft ? resolvedRadius : 0,
          borderBottomLeftRadius: isLeft ? resolvedRadius : 0,
          borderTopRightRadius: !isLeft ? resolvedRadius : 0,
          borderBottomRightRadius: !isLeft ? resolvedRadius : 0,
        }}
      />

      {/* Contenu */}
      <div
        style={{
          padding: `${paddingV ?? cfg.paddingV}px ${paddingH ?? cfg.paddingH}px`,
          flex: 1,
          minWidth: 0, // Permet un shrink correct du texte en flex-row
        }}
      >
        {title && (
          <div
            style={{
              fontSize: cfg.titleSize,
              margin: `0 0 ${cfg.gap}px 0`,
              fontWeight: theme.fontWeights.semiBold,
              color: palette.title,
              lineHeight: 1.3,
            }}
          >
            {title}
          </div>
        )}

        <div
          style={{
            margin: 0,
            color: palette.text,
            fontSize: cfg.messageSize,
            lineHeight: 1.5,
            whiteSpace: "normal",
          }}
        >
          {message}
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
